export const ALLOWED_DOCUMENT_MIMETYPES = [
  'video/mp4',
  'video/quicktime',
  'image/png',
  'image/jpeg',
  'image/jpeg',
  'image/gif',
  'image/bmp',
];
